import { createStyles, IconButton, makeStyles } from '@material-ui/core';
import { Print as PrintIcon } from '@material-ui/icons';
import React from 'react';
import { useDocumentData, useLocalization } from "../../hooks/index.js";
const useStyles = makeStyles(() => {
  return createStyles({
    iconButton: {
      display: 'inline-block'
    },
    icon: {}
  });
});

/**
 * Own properties for the Print component
 */

/**
 * Component that allows print
 */
export const Print = props => {
  const classes = useStyles(props);
  const localization = useLocalization();
  const {
    documentData
  } = useDocumentData();
  return /*#__PURE__*/React.createElement(IconButton, {
    className: classes.iconButton,
    color: "inherit",
    title: localization.print,
    onClick: () => props.print(documentData),
    id: "Print"
  }, /*#__PURE__*/React.createElement(PrintIcon, {
    className: classes.icon
  }));
};
//# sourceMappingURL=print-widget.js.map